import type { QueryHookOptions } from '@apollo/client'

import { type GetClassroomsQuery, type GetClassroomsQueryVariables, useGetClassroomsQuery } from '@app/data'

export const useClassrooms = (baseOptions?: QueryHookOptions<GetClassroomsQuery, GetClassroomsQueryVariables>) => {
  const { data, loading, error } = useGetClassroomsQuery({
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    ...baseOptions
  })

  return {
    classrooms: data?.classrooms,
    error,
    loading
  }
}
